import constants from "../../constants";
import { useContext, useState } from "react";
import AlertContext from "../../context/AlertContext";

export default function ScoreHooks() {
  const Alert = useContext(AlertContext);

  const [PHtext, setPHtext] = useState("0");
  const [minExtenDate, setMinExtenDate] = useState();
  const [scoreValid, setScoreValid] = useState(true);
  const [extensionDate, setExtensionDate] = useState();
  const [showApprove, setShowApprove] = useState(false);
  const [minExtenDateValue, setMinExtenDateValue] = useState(true);

  const changeScore = (event) => {
    if (isNaN(event.target.value) || event.target.value === "") {
      Alert.setScore("");
    } else {
      Alert.setScore(Number(event.target.value));
    }
  };

  const toggleDrawerScore = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    
    Alert.setShowScore(!Alert.showScore);
  };

  const getScore = () => {
    if (
      Alert.testDetail.libtypeid === constants.libTypeIds.ASSIGNMENT ||
      Alert.testDetail.libtypeid === constants.libTypeIds.CODING_CHALLENGE
    ) {
      return (
        (Alert.approveData.actualscore !== null
          ? Alert.approveData.actualscore
          : 0) +
        "/" +
        Alert.approveData.marks
      );
    } else if (Alert.testDetail.libtypeid === constants.libTypeIds.SQL) {
      const totalActualScore = Alert.testDetail.data.sections[0].questions
      .reduce((sum, q) => sum + (q.actualscore || 0), 0);

      const totalTargetScore = Alert.testDetail.data.sections[0].questions
      .reduce((sum, q) => sum + (q.targetscore || 0), 0);
      
      return totalActualScore + "/" + totalTargetScore;
    } else {
      return parseFloat((Alert.totalLearnerScore).toFixed(2)) + "/" + Alert.totalTestScore;
    }
  };

  return {
    PHtext,
    getScore,
    setPHtext,
    scoreValid,
    changeScore,
    showApprove,
    minExtenDate,
    setScoreValid,
    extensionDate,
    setShowApprove,
    setMinExtenDate,
    setExtensionDate,
    toggleDrawerScore,
    minExtenDateValue,
    setMinExtenDateValue,
  };
}
